import I18n from 'i18n-js';
import { capitalizeWords } from '@/modules/TCIUtils';
import { getSectionsByKind } from '@/components/shared/LessonOverview/utils';

export const readingLabel = (type) => {
  const label = type === 'biography' ? 'profiles_in_history' : type;
  const allCaps = capitalizeWords(I18n.t(label.replace(/ /g, '_')));

  return allCaps.replace(' The ', ' the ').replace(' To ', ' to ').replace(' In ', ' in ');
};

export const diveDeeperFormat = (lesson, sections) => {
  const sectionsByKind = getSectionsByKind(sections);

  const readingTypes = Object.keys(sectionsByKind).filter(kind => (
    !['default', 'unit projects', 'key science concept'].includes(kind)
  ));

  return {
    readings: readingTypes.flatMap(type => sectionsByKind[type]),
    referenceMaterialAssignments: lesson?.referenceMaterialAssignments || [],
    taggedReferenceMaterials: lesson?.taggedReferenceMaterials || [],
  };
};
